/**
 * JANコードの検証ユーティリティ
 */

/**
 * JANコードが有効かどうかを検証する
 * @param jan 検証するJANコード文字列
 * @returns JANコードが有効な場合はtrue、無効な場合はfalse
 *
 * 有効なJANコード:
 * - 数字のみで構成される
 * - 8桁（短縮形）または13桁（標準形）
 */
export function isValidJan(jan: string): boolean {
  // `isNaN(Number(jan))` で判定していたが、Number() は 16 進リテラル (0x123456) や
  // 前後の空白 ("\n1234567") を受け付けるため、数字以外でも桁数が合えば通ってしまっていた。
  // 半角数字だけを許可する。`\d` は全角数字にはマッチしない。
  if (!jan || !/^\d+$/.test(jan)) {
    return false;
  }
  const len = jan.length;
  return len === 8 || len === 13;
}
